import React from 'react'
import { toast } from 'react-toastify'
import { useTranslation } from 'react-i18next'

import {ReactComponent as IconCheckBlack} from '../assets/icons/ic-check-black.svg'
import {ReactComponent as IconCheckGreen} from '../assets/icons/ic-check-green.svg'
import {ReactComponent as IconNotice} from '../assets/icons/ic-notice.svg'

const useToast = ({ isSuccess = false, isMsg = false, msg }) => {
    const SuccessToast = () => {
        const { t } = useTranslation();
        return (
            <div className="h-[34px] flex items-center justify-center px-5 py-2 bg-[#DEDEDE]" style={{ minWidth: 204, borderRadius: 6, boxShadow: '0px 12px 12px 0px #00000099' }}>
                <IconCheckGreen className="mr-1 mb-1"/>
                <div className="relative text-[#146830]" style={{ fontWeight: 500, fontSize: 16, lineHeight: '17.6px' }}>{msg ? `${msg}` : t('error.savedSuccess')}</div>
            </div>
        )
    }

    const ErrorToast = () => {
        const { t } = useTranslation();
        return (
            <div className="h-[34px] flex items-center justify-center px-5 py-2 bg-[#DEDEDE]" style={{ minWidth: 204, borderRadius: 6, boxShadow: '0px 12px 12px 0px #00000099' }}>
                <IconNotice className="mr-1 mb-1"/>
                <div className="relative text-[#C50024] truncate" style={{ fontWeight: 500, fontSize: 16, lineHeight: '17.6px' }}>{ msg ? t('error.toastError', { msg }) : t('error.defaultError')}</div>
            </div>
        )
    }

    const MessageToast = () => {
        const { t } = useTranslation();
        return (
            <div className="h-[34px] flex items-center justify-center px-5 py-2 bg-[#DEDEDE]" style={{ minWidth: 204, borderRadius: 6, boxShadow: '0px 12px 12px 0px #00000099' }}>
                <IconCheckBlack className="mr-1 mb-1"/>
                <div className="relative text-[#121212] truncate" style={{ fontWeight: 500, fontSize: 16, lineHeight: '17.6px' }}>{ msg ? t('error.toastMessage', { msg }) : t('error.defaultError') }</div>
            </div>
        )
    }

    return toast(isMsg ? <MessageToast /> : isSuccess ? <SuccessToast /> : <ErrorToast />)
}

export default useToast